<template>
  <validation-provider
    :rules="rules"
    v-slot="{ errors }"
    :name="name"
    :immediate="immediate"
    :vid="vid"
  >
    <label v-if="label">
      {{ label }}
    </label>
    <div class="uk-form-icon uk-width-1-1 uk-form-large">
      <i class="uk-icon-calendar"></i>
      <flat-pickr
        v-model="iValue"
        :config="config"
        class="datepicker uk-width-1-1 uk-form-large uk-input"
        :class="{
          'invalid': errors.length
        }"
        :placeholder="placeholder"
        @on-change="onChanged"
      />
      <span v-show="errors.length" class="error">{{ errors[0] }}</span>
    </div>
  </validation-provider>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    name: {
      required: false,
    },
    label: {
      required: false,
    },
    required: {
      default: false,
      required: false,
    },
    disabled: {
      required: false,
      default: false
    },
    rules: {
      required: false,
      default: null
    },
    immediate: {
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
    },
    config: {
      type: Object,
      default: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
      }
    }
  },
  created() {
  },
  data() {
    return {
    }
  },
  computed: {
    iValue: {
      get () { return this.value; },
      set (v) {
        this.$emit('input', v)
      },
    },
    vid() {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
    }
  },
  methods: {
    onChanged($event) {
      this.$emit('changed', $event);
      console.log($event);
    }
  }
};
</script>
<style lang="scss">
  .datepicker.invalid + input.input {
    border-color: #dc8d99!important;
    background: #fff7f8!important;
    color: #d85030!important;
  }
</style>
